import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

/**
 * Einstiegspunkt mit harter Trennung zweier Bundles.
 *
 * Die öffentliche Buchungsstrecke (/b/*, /embed/*) lädt einen eigenen Chunk ohne
 * QueryClient, Toaster, ThemeProvider, axios, zustand und @werkstatt/ui.
 * Das Backoffice bleibt vollständig davon getrennt — siehe docs/05-frontend.md §5.
 */
const PublicApp = lazy(() => import('./PublicApp'));
const AdminApp = lazy(() => import('./AdminApp'));

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-sm text-slate-500">Wird geladen…</p>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/b/*" element={<PublicApp />} />
          <Route path="/embed/*" element={<PublicApp embedded />} />
          <Route path="*" element={<AdminApp />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
